import "./style.scss";
export default function HealthWarning() {
  return (
    <div className="health-warning">
      <p className="copy">
        Nur für Erwachsene. Nikotinprodukte schaden der Gesundheit und
        machen abhängig.
      </p>
    </div>
  );
}
